(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jewelry-showcase"] && !Shopify.designMode) return;
  try {
    
const images = document.querySelectorAll('.jewelry-img');
const section = document.querySelector('.jewelry-section');

function slideInImages() {
  const sectionTop = section.getBoundingClientRect().top;
  const sectionBottom = section.getBoundingClientRect().bottom;
  const triggerPoint = window.innerHeight * 0.75;
  
  // Check if section is in viewport
  if (sectionTop < triggerPoint && sectionBottom > 0) {
    images.forEach(img => {
      img.classList.add('visible');
    });
  } else {
    // Optional: remove visible class when scrolled away (for repeat animation)
    images.forEach(img => {
      img.classList.remove('visible');
    });
  }
}

// Only trigger on scroll, NOT on load
window.addEventListener('scroll', slideInImages);

// Call once on scroll to check initial position
slideInImages();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
